module.exports = __webpack_public_path__ + "iphoneduo-star-white.7e2cb044.png";